import React, { useRef } from "react";
import Typography from "@mui/material/Typography";
import "react-medium-image-zoom/dist/styles.css";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import {
  DashedBorderStyle,
  captionWithBorders,
  generateOrderedList,
  getCircleTypeListItem,
  getTextContentHeading,
  getTextContentWithHeading,
  h1style,
  h2style,
  h3style,
  paraStyle,
  referenceHtml,
  referenceTootKit,
  sectionStyle,
  subHeadingContent,
  tableCaption,
} from "./ChapterList";
import objective from "../../../assets/SvgIcons/obj.svg";
import user from "../../../assets/SvgIcons/users.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import highCourtESeva from "../../../assets/Images/Karnataka_High_court_eSeva_interior.jpg";
import vc_cabin from "../../../assets/Images/eSevaKendra Images/VC_Cabins.jpeg";
import eSevaKendraImg from "../../../assets/Images/eSevaKendra Images/e_Seva.png";
import eSevaInterior from "../../../assets/Images/eSevaKendra Images/Renders_ESeva_Interior.png";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import ESevaTable1 from "./Common/esevaTable1";
import { table1, table2 } from "../../../utils/eSevaTableData";
import { FigureDesc58, FigureDesc59, ImageDesc64, ImageDesc65 } from "../../../utils/tmp/ImageDescription/eSevaKendraID";

const referenceStyle = {
  color: "black",
  fontFamily: "GT Super Text",
  fontSize: " 24px",
  fontWeight: "700",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "italic",
  cursor: "pointer",
  marginBottom: "10px",
};

const ESevaKendra = ({ goToSection }) => {
  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };
  const referenceData = [
    {
      content: "e-Courts Phase III Vision Document.",
    },
    {
      content: " e-Seva Kendra Guidelines. ",
    },
    {
      content: "Model Live Streaming Rules. ",
    },
    {
      content: (
        <>
          {" "}
          ‘e-Seva Kendra at High Court of Karnataka’{" "}
          <i>(Karnataka Judiciary)</i>{" "}
        </>
      ),
      link: "https://karnatakajudiciary.kar.nic.in/eseva.php",
      description: "<https://karnatakajudiciary.kar.nic.in/eseva.php>",
    },
    {
      content: (
        <>
          {" "}
          ‘e-Seva Kendra, Shivamogga District Court’ <i>(eCourts)</i>{" "}
        </>
      ),
      link: "https://shivamogga.dcourts.gov.in/",
      description:
        "<https://shivamogga.dcourts.gov.in/> [“Shivamogga District Court e-Seva Kendra”]",
    },
    {
      content: "e-Seva Kendra Guidelines, s 4.9. ",
    },
    { content: "e-Seva Kendra Guidelines, s 4.12. " },
    { content: "Model Video Conferencing Rules. " },
  ];
  const scrollThreshold = 1100;

  const pointStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: "10px 30px",
  };
  const objectivesObject = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        Design the counters of the e-Seva Kendra to be{" "}
        <span style={{ color: "#DC002D" }}>
          accessible for all litigants and Advocates
        </span>{" "}
        visiting the space;
      </>,
      <>
        Facilitate{" "}
        <span style={{ color: "#DC002D" }}>access to online filing </span>of
        cases or applications, including the scanning of physical documents,
        generation of e-signatures and uploading into the Case Information
        System (“CIS”) of the Court, and guidance on filing procedures;
      </>,
      <>
        Facilitate{" "}
        <span style={{ color: "#DC002D" }}>
          e-hearings for Advocates or litigants
        </span>{" "}
        who may not have access to the necessary resources;
      </>,
      <>
        Ensure{" "}
        <span style={{ color: "#DC002D" }}>easy access to information</span> on
        case status, e-payment facilities, and other queries regarding the
        working of the Court such as information regarding the location of
        various Courtrooms, judges on leave, causelists, etc.;
      </>,
      <>
        Promote{" "}
        <span style={{ color: "#DC002D" }}>
          access to technological services
        </span>{" "}
        such as e-Courts Mobile App, JUSTIS App, etc., for lawyers and
        litigants;{" "}
      </>,
      <>
        {" "}
        Provide{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          guidance regarding legal aid services
        </span>
        , to be provided by the District Legal Services Authority;
      </>,
      <>
        Provide{" "}
        <span style={{ color: "#DC002D" }}>
          facilities and assistance to any users with special needs
        </span>{" "}
        including Persons with Disabilities, elderly persons, pregnant women,
        etc.;
      </>,
      <>
        {" "}
        Provide{" "}
        <span style={{ color: "#DC002D" }}>
          {" "}
          facilities for fast-track disposal{" "}
        </span>{" "}
        of traffic challans in virtual Courts, and other case types which may be
        incorporated as part of the virtual Courts framework in the future; and
      </>,
      <>
        Provide{" "}
        <span style={{ color: "#DC002D" }}> access to soft copies </span> of
        judicial orders/judgments, etc.{" "}
      </>,
    ],
    isOrdered: false,
    isImage: true,
  };
  const usersESevaData = [
    "Judicial assistants from the Court, with knowledge of handling computer devices; and",
    <>
      Para-legal volunteers/contractual staff for manning counters, depending on
      the workload of the Court.{reference(referenceData[1], 2)}
    </>,
  ];
  const adjacenciesESevaData = [
    "An external counter for the public/litigants, accessible by all; and",
    "An internal counter for staff, accessed from a secure private entry for the Court staff. ",
  ];
  const usersObject = {
    icon: <img src={user} />,
    heading: "Users",
    data: [
      <>Litigants</>,
      <>Advocates</>,
      <>e-Seva Kendra staff:{getCircleTypeListItem(usersESevaData, true)}</>,
      <>
        All visitors requiring assistance regarding any Court processes and
        procedures
      </>,
    ],
    idOrdered: false,
    isImage: true,
  };

  const adjacenciesObject = {
    icon: <img src={adjacencies} />,
    heading: "Adjacencies",
    data: [
      <>
        The e-Seva Kendra must ideally be a separate block, located in close and
        visible proximity to the public entrance of the Court building. If the
        e-Seva Kendra is designed as part of the Court building itself, a
        separate, dedicated space must be provided on the ground floor, near the
        entrance lobby.
      </>,

      <>
        In such cases where the e-Seva Kendra is within the Court building, it
        must be in close proximity to or have direct access to the public
        waiting areas.
      </>,
      <>
        It must be in close proximity to accessible sanitary provisions and a
        pantry area.
      </>,
      <>
        The e-Seva Kendra must have:{" "}
        {getCircleTypeListItem(adjacenciesESevaData, true)}
      </>,
      <>
        The e-Seva Kendra must be located in proximity to the administrative
        wing, particularly the filing section and the copying/dispatch sections.
      </>,
    ],
    isOrdered: false,
    isImage: true,
  };

  const designObject = [
    {
      icon: <img src={designConsideration} />,
      heading: "Design Considerations",
      items: [
        "The e-Seva Kendra must have an adequate number of help desks, depending on the available capacity of the room and the workload of the Court.",
        "All spaces in the e-Seva Kendra must be equipped with modular and ergonomic seating, and provision must be made for natural light and ventilation, including good acoustics.",
        "The e-Seva Kendra must have adequate storage space for storing of files and pamphlets/other information as required, and for the personal belongings of the staff.",
        <>
          As per the Model Rules for Live Streaming and Recording of Court
          Proceedings,{reference(referenceData[2], 3)} the following specific
          design considerations must be kept in mind to ensure compliance with
          the rules:
          <div style={{ margin: "30px 0" }}>
            <p className="table-guidance-heading">
              <span className="table-guidline-text">Table 11: </span>
              <br />
              <span style={tableCaption}>
                Design considerations arising from the Model Rules for Live
                Streaming and Recording of Court Proceedings.
              </span>
            </p>
            <ESevaTable1 tableData={table1} />
          </div>
        </>,
      ],
    },
    {
      heading: "Waiting Area",
      items: [
        <>
          In such cases where the e-Seva Kendra is a separate block, a waiting
          area must be provided at the entrance, in accordance with the design
          considerations highlighted in{" "}
          <span
            onClick={() => goToSection("waitingArea", "headingWaitingAreas")}
            style={sectionStyle}
          >
            {" "}
            Section 2.2.
          </span>
        </>,
        "The waiting area must be equipped with accessible infographics and signage explaining the services being provided at the e-Seva Kendra, including specialised services being provided to cater to the needs of diverse user groups. A designated counter must be provided to ensure speedy delivery of such assistance. ",
        "The waiting area must have information kiosks and case display boards, with audible announcements, showcasing information from all Courtrooms in the Complex.",
        "All information must be made available in an accessible format and in local languages.",
      ],
    },
    {
      heading: "Help Desk and Counters",
      items: [
        "The e-Seva Kendra must be equipped with multiple user-friendly and accessible counters, depending on the workload of the Court, to facilitate uninterrupted person-to-person interaction between the e-Seva Kendra staff and litigants/lawyers",
        "A detailed map of the entire Court Complex must be displayed at the counters or at an accessible location in close proximity to the counters.",
        <>
          Accessible e-kiosk/electronic system and computer facilities,
          including use of USB drives/other external storage devices, must be
          provided to facilitate e-filing.{reference(referenceData[3], 4)}
        </>,
        "Provision must be made for online payment of Court fees, process fees, etc., as required, and for generation of payment receipts. ",
      ],
    },
    {
      heading: "Video-Conference Cabins",
      items: [
        <>
          Multiple video-conference cabins (keeping in mind the workload and
          capacity of the Court) must be provided in the e-Seva Kendra for the
          use of lawyers and litigants.{reference(referenceData[4], 5)}
        </>,
        "Accessible signage and digital display boards, including boards used for queue management to prevent overcrowding near the cabin, must be provided.",
        "These cabins must be equipped with video-conferencing systems and additional audio-visual equipment, to facilitate any lawyers/litigants to undertake any e-hearings, if required.",
        <>
          These cabins must be acoustically treated to ensure privacy and
          confidentiality, wherever necessary. For further details on acoustics,
          please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure5")}
          >
            Annexure 5.
          </span>
        </>,
        <>
          IT hardware such as computers and scanners with access to Case
          Information System (CIS), along with high-speed internet facility,
          must be provided in the cabins.{reference(referenceData[5], 6)}{" "}
          Self-help touch-screen eKiosks must additionally be provided.
          {reference(referenceData[6], 7)}
        </>,
        "All digital interfaces must be accessible for diverse users including Persons with Disabilities, and must be at adequate height and include features such as adjustable font sizes and compatibility with screen readers.",
        <>
          As per the Video Conferencing Rules,{reference(referenceData[7], 8)}{" "}
          the following specific design considerations must be kept in mind to
          ensure compliance with the rules:
        </>,
      ],
    },
  ];

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C - THE HANDBOOK
        </h1>
        <h2 id="HeadingChapterTwo" style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 id="paraLegalFacilities" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.8. </span>
          Para-Legal Facilities
        </h3>
        <h4 id="eSevaKendra" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.8.</span>A. e-Seva Kendra
        </h4>
        <p style={paraStyle}>
          The e-Seva Kendra is a facility that acts as the first line of contact
          between litigants and the judicial system to access services related
          to the e-Courts Project. Under Phase III of the e-Courts Project, all
          District Courts in the country are required to set up e-Seva Kendras
          to facilitate easy communication and coordination between staff and
          litigants/Advocates.{reference(referenceData[0], 1)}
        </p>
        <p style={paraStyle}>
          Further, the e-Courts Project seeks to ensure that e-filing shall be
          the preferred method of filing cases in the future. Therefore, as the
          e-Seva Kendra will provide e-filing assistance, it is envisioned to
          eventually function as the filing counter in place of the existing
          physical filing counters (
          <span
            onClick={() => goToSection("filingSection", "headingFilingSection")}
            style={sectionStyle}
          >
            Section 2.5.A
          </span>
          ) once e-filing has been made mandatory.
        </p>
        {getTextContentHeading(objectivesObject)}
        {getTextContentHeading(usersObject)}
        {getTextContentHeading(adjacenciesObject)}
        {subHeadingContent(designObject)}

        <div style={{ margin: "30px 0" }}>
          <p className="table-guidance-heading">
            <span className="table-guidline-text">Table 12: </span>
            <br />
            <span style={tableCaption}>
              Design considerations arising from the Model Video Conferencing
              Rules.
            </span>
          </p>
          <ESevaTable1 tableData={table2} />
        </div>

        <CaptionWithBorders1
          image={[highCourtESeva]}
          caption={
            "Image 64: Example of IT infrastructure for e-filing at High Court of Karnataka, Bangalore"
          }
          creditLabel="Source"
          imageCredit="Karnataka High Court"
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc64}
        />

        <CaptionWithBorders1
          image={[vc_cabin]}
          caption={
            "Image 65: Example of dedicated video-conferencing cabins at the e-Seva Kendra established in Shivamogga District Court, Karnataka"
          }
          creditLabel={"Source"}
          imageCredit={"Shivamogga District Court e-Seva Kendra"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc65}
        />

        <CaptionWithBorders1
          image={[eSevaKendraImg]}
          isZoom={true}
          caption={"Figure 58: Typical floor plan for the e-Seva Kendra"}
          zoomImgStyle={{ height: "580px" }}
          imageDescription={FigureDesc58}
        />

        <CaptionWithBorders1
          image={[eSevaInterior]}
          isZoom={true}
          caption={"Figure 59: Representation of the e-Seva Kendra"}
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc59}
        />

        <h2 ref={referencesRef} id="eSevaRef" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default ESevaKendra;
